import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Award, BarChart3, Camera, Newspaper, Shield, Trophy, Video } from "lucide-react";
import { ClubCrest } from "@/components/fsl/ClubCrest";
import { api } from "@/lib/api";

const QUICK = (slug) => [
  [Trophy, "Classifiche", `/tornei/${slug}/classifiche`, "explore-standings"],
  [BarChart3, "Marcatori e premi", `/tornei/${slug}/statistiche`, "explore-stats"],
  [Award, "Top 11", `/tornei/${slug}/top11`, "explore-top11"],
  [Newspaper, "Interviste e blog", `/tornei/${slug}/news`, "explore-news"],
  [Camera, "Gallery", `/tornei/${slug}/news?tipo=gallery`, "explore-gallery"],
  [Video, "Video", `/tornei/${slug}/news?tipo=video`, "explore-video"],
];

export function ExploreTournaments({ slugs }) {
  const [data, setData] = useState({});
  useEffect(() => {
    slugs.forEach((slug) => { if (!data[slug]) api.get(`/public/tournaments/${slug}`).then((r) => setData((d) => ({ ...d, [slug]: r.data }))).catch(() => {}); });
  }, [slugs]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!slugs.length) return null;
  return (
    <section data-testid="fan-explore-section">
      <h2 className="fsl-section-title mb-1 flex items-center gap-2"><Shield className="h-5 w-5 text-fsl-gold" /> Società e contenuti</h2>
      <p className="text-xs text-fsl-slate mb-4">Apri la home di ogni società per rose, foto, video, interviste e blog; qui sotto classifiche, marcatori e premi sempre aggiornati.</p>
      <div className="space-y-6">
        {slugs.map((slug) => { const h = data[slug]; if (!h) return null; const clubs = [...(h.clubs || [])].sort((a, b) => a.name.localeCompare(b.name)); return (
          <div key={slug} className="fsl-card p-4 space-y-4" data-testid={`explore-${slug}`}>
            <div className="flex flex-wrap items-center justify-between gap-2"><Link to={`/tornei/${slug}`} className="font-display font-extrabold uppercase text-xl hover:text-fsl-gold" data-testid={`explore-home-${slug}`}>{h.tournament.name}</Link><span className="text-xs text-fsl-slate">{clubs.length} società</span></div>
            <div className="flex flex-wrap gap-2">{QUICK(slug).map(([Icon, label, to, tid]) => <Link key={to} to={to} className="btn-ghost h-9 px-3 text-xs" data-testid={`${tid}-${slug}`}><Icon className="h-3.5 w-3.5" /> {label}</Link>)}</div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2">{clubs.map((c) => <Link key={c.id} to={`/tornei/${slug}/squadre/${c.slug}`} className="flex items-center gap-2 rounded-xl border border-white/10 bg-navy-700/40 px-3 py-2 hover:border-fsl-gold/60 transition-colors" data-testid={`explore-club-${c.slug}`}><ClubCrest club={c} size={28} /><span className="text-sm font-semibold truncate">{c.name}</span></Link>)}</div>
          </div>
        ); })}
      </div>
    </section>
  );
}
